<template>
  <div>
    {{ $t("custom.results_per_page") }}

    <button
      class="-mx-px ml-2 h-9 w-10 rounded-l border border-solid border-gray-300 text-center text-sm uppercase"
      :class="[
        activeItems === 16 ? 'bg-[color:var(--color-primary-500)] font-bold text-white' : 'bg-white font-medium',
      ]"
      type="button"
      @click="$emit('update:itemsPerPage', 16)"
    >
      16
    </button>
    <button
      class="-mx-px h-9 w-10 border border-solid border-gray-300 text-center text-sm uppercase"
      :class="[
        activeItems === 32 ? 'bg-[color:var(--color-primary-500)] font-bold text-white' : 'bg-white font-medium',
      ]"
      type="button"
      @click="$emit('update:itemsPerPage', 32)"
    >
      32
    </button>
    <button
      class="-mx-px h-9 w-10 rounded-r border border-solid border-gray-300 text-center text-sm uppercase"
      :class="[
        activeItems === 48 ? 'bg-[color:var(--color-primary-500)] font-bold text-white' : 'bg-white font-medium',
      ]"
      type="button"
      @click="$emit('update:itemsPerPage', 48)"
    >
      48
    </button>
  </div>
</template>

<script setup lang="ts">
import { DEFAULT_PAGE_SIZE } from "@/core/constants";

defineProps({
  loading: Boolean,

  activeItems: {
    type: Number,
    default: DEFAULT_PAGE_SIZE,
  },
});
</script>
